import { EventClass, EventType } from "../../../_game/config/Events";
import { KENO_GAME_TYPE, MENU_POPUPS } from "../../../_game/config/Game";
import { RGSActions } from "../../config/config.Connections";
import {
  __UrlParams,
  __Utils,
  __ProxiProvider,
  __EventDispatcher,
  __CurrentConnection,
} from "../../core";
import { store } from "../../core.Store";
import {
  action_setGameplayData,
  action_setUserHistory,
  action_setUserTickets,
} from "../../store/actions/actions.Game";
import {
  setGameplayData,
  setServerResponse,
  setStatusData,
} from "../../store/slices/slice.Game";

export const action_normalizeResponseMarlipin =
  (rcvPayload: any) => (dispatch: any) => {
    const newpayload: any = {};

    switch (rcvPayload.COMMAND.type) {
      case RGSActions.LOGIN:
        newpayload.SESSION_DATA = {
          isFun: __UrlParams.props.funReal,
          currency: rcvPayload.DATA.currency,
          sessionID: rcvPayload.DATA.playerDetails.sessionID,
          fixedID: rcvPayload.DATA.playerDetails.fixedReference,
          // bet data
          betIndex: rcvPayload.DATA.stakeValues.indexOf(
            rcvPayload.DATA.defaultStake
          ),
          betLevels: rcvPayload.DATA.stakeValues,
          // regulatory
          configuration: {
            slamStopAllowed: true,
            showAutoplay: true,
            fastSpinModeAllowed: true,
          },
        };

        // free spins
        if (
          typeof rcvPayload.DATA.bonusCredit !== "undefined" &&
          rcvPayload.DATA.bonusCredit.length > 0
        ) {
          // save free spins data
          const bonus = rcvPayload.DATA.bonusCredit[0];
          if (bonus.canUse === true /* && bonus.remainingBets > 0*/) {
            // announce non fixed bonus rounds
            if (bonus.stakeFixed === false) {
              console.error("PROMOTION with non fixed stake! Unsupported!");
            }

            newpayload.SESSION_DATA.freeBets = {
              bonusRef1: bonus.bonusRef1,
              bonusRef2: bonus.bonusRef2,
              remainingFreeSpins: bonus.remainingBets,
              totalFreeSpins: bonus.amount,
              used: bonus.amount - bonus.remainingBets,
              amount: bonus.stakeAmount,
              winnings: bonus.wonSoFar,
            };
          } else {
            console.log("PROMOTION received taht cannot be used!");
          }
        }

        newpayload.STATUS_DATA = {
          credit: rcvPayload.DATA.credit.amount,
          bet: rcvPayload.DATA.defaultStake,
        };
        newpayload.USER_DATA = {
          credit: rcvPayload.DATA.credit.amount,
          bet: rcvPayload.DATA.defaultStake,
        };

        dispatch(
          setStatusData({
            bet: rcvPayload.DATA.defaultStake,
          })
        );

        __ProxiProvider.updateBalance(
          newpayload.USER_DATA.credit,
          newpayload.USER_DATA.bet
        );
        dispatch(setServerResponse(newpayload));
        break;

      case RGSActions.BALANCE:
        newpayload.USER_DATA = {
          credit: rcvPayload.DATA.credit.amount,
          bet: rcvPayload.DATA.defaultStake,
        };
        newpayload.STATUS_DATA = {
          credit: rcvPayload.DATA.credit.amount,
          bet: rcvPayload.DATA.defaultStake,
        };

        dispatch(setServerResponse(newpayload));

        __ProxiProvider.updateBalance(
          newpayload.USER_DATA.credit,
          newpayload.USER_DATA.bet
        );
        break;

      case RGSActions.INIT:
        normalize_SetUp(rcvPayload, dispatch);
        break;
      case RGSActions.BETS:
        normalize_Bets(rcvPayload, dispatch).then(() => {
          const _cState = store.getState();

          //@ts-ignore
          if (
            _cState.game.COMM_STATUS.lastCommand &&
            //@ts-ignore
            _cState.game.COMM_STATUS.lastCommand.type.indexOf([
              RGSActions.BALANCE,
              RGSActions.PLAY,
            ])
          ) {
            __EventDispatcher.dispatch(
              EventClass.GAMEPLAY,
              EventType.GAMEPLAY.ROUND_END,
              {
                tickets: _cState.game.GAMEPLAY.tickets,
              }
            );
            setTimeout(() => {
              __EventDispatcher.dispatch(
                EventClass.GUI,
                EventType.GUI.CLEAR_POPUP
              );
            }, 2500);
          }
        });
        break;
      case RGSActions.LAST_DRAW_RESULTS:
        normalize_LastResults(rcvPayload, dispatch);
        break;
      case RGSActions.FAILED_BETS:
        normalize_FailedBets(rcvPayload, dispatch);
        break;
      case RGSActions.SUBSCRIPTION:
        normalize_Subscriptions(rcvPayload, dispatch);
        break;
      case RGSActions.PLAY:
      case RGSActions.PLAY_PROMOTION:
        normalize_Play(rcvPayload, dispatch);
        break;
    }
  };

enum BROADCAST_RESPONSE_TYPES {
  CLOSE = "close",
  RESULTS = "results",
}

export const action_normalizeResponseBroadcast =
  (rcvPayload: any) => (dispatch: any) => {
    switch (rcvPayload.DATA.requestType) {
      case BROADCAST_RESPONSE_TYPES.CLOSE:
        dispatch(
          setGameplayData({
            bettingOpen: false,
          })
        );
        break;
      case BROADCAST_RESPONSE_TYPES.RESULTS:
        dispatch(
          setGameplayData({
            drawResults: rcvPayload.DATA.lottery.numbers,
            drawCurrentNumber: rcvPayload.DATA.lottery.numbers[0] || 0,
            drawStart: true,
            drawNumber: rcvPayload.DATA.lottery.nextDrawNumber,
          })
        );
        break;
    }
  };

//normalizes bets request
const normalize_Bets = (rcvPayload: any, dispatch: any) =>
  new Promise<void>((resolve, reject) => {
    const _cState = store.getState();
    const _drawNumber = _cState.game.GAMEPLAY.nextDrawNumber;

    if (
      rcvPayload.DATA.lottery &&
      (rcvPayload.DATA.lottery.nextDraw ||
        rcvPayload.DATA.lottery.previousDraws)
    ) {
      const _tickets = rcvPayload.DATA.lottery.nextDraw;

      let currentTickets = _tickets.filter((_ticket: any) => {
        return (
          _drawNumber === _ticket.drawNumber &&
          _ticket.kenoGameType === KENO_GAME_TYPE
        );
      });

      dispatch(action_setUserTickets(currentTickets));
      dispatch(action_setUserHistory(rcvPayload.DATA.lottery.previousDraws));
      resolve();
    }
  });

const normalize_LastResults = (rcvPayload: any, dispatch: any) => {
  dispatch(
    setGameplayData({
      drawEnds: true,
      totalWinOnLastDraw: rcvPayload.DATA.lottery.totalWinOnLastDraw,
    })
  );
};

// normalizes setup/login answers
const normalize_SetUp = (rcvPayload: any, dispatch: any) => {
  const newpayload: any = {};

  newpayload.GAME_DATA = {
    ...rcvPayload.DATA.lottery,
  };
  newpayload.USER_DATA = {
    credit: rcvPayload.DATA.credit.amount,
  };

  dispatch(
    setStatusData({
      credit: rcvPayload.DATA.credit.amount,
    })
  );

  dispatch(setServerResponse(newpayload));

  dispatch(
    setGameplayData({
      timer: rcvPayload.DATA.lottery.drawClosesSeconds,
      bettingOpen: rcvPayload.DATA.lottery.bettingOpen,
      drawNumber: rcvPayload.DATA.lottery.nextDrawNumber,
      nextDrawNumber: rcvPayload.DATA.lottery.nextDrawNumber,
    })
  );
};

// normalizes play answers
const normalize_Play = (rcvPayload: any, dispatch: any) => {
  const newpayload: any = {};
  const lStore = store.getState();

  if (__Utils.isSet(rcvPayload.DATA.lottery)) {
    // dispatch(action_cleanSelectedNumbers());

    const lottery = rcvPayload.DATA.lottery;
    if (__Utils.isSet(lottery.chosenNumers)) {
      if (lStore.game.GAMEPLAY.nextDraws <= 1) {
        dispatch(
          action_setGameplayData({
            roundStart: false,
          })
        );
      }

      dispatch(setServerResponse(newpayload));
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
        type: MENU_POPUPS.POPUP_SUCCESS,
      });

      __CurrentConnection.updateBalance();
    }
  }

  dispatch(setServerResponse(newpayload));
};

const normalize_Subscriptions = (rcvPayload: any, dispatch: any) => {
  dispatch(
    action_setGameplayData({
      roundStart: false,
    })
  );
};

const normalize_FailedBets = (rcvPayload: any, dispatch: any) => {
  if (
    (rcvPayload.DATA.lottery.cancelledBets &&
      rcvPayload.DATA.lottery.cancelledBets.length > 0) ||
    (rcvPayload.DATA.lottery.failedBets &&
      rcvPayload.DATA.lottery.failedBets.length > 0) ||
    (rcvPayload.DATA.lottery.toBeCancelledBets &&
      rcvPayload.DATA.lottery.toBeCancelledBets.length > 0)
  ) {
    const cancelledBets = rcvPayload.DATA.lottery.cancelledBets.map(
      (el: any) => ({
        betID: el.betId,
        extBetID: el.extBetID,
        status: "CANCELLED",
      })
    );
    const failedBets = rcvPayload.DATA.lottery.failedBets.map((el: any) => ({
      betID: el.betId,
      extBetID: el.extBetID,
      status: "FAILED",
    }));
    const toBeCancelledBets = rcvPayload.DATA.lottery.toBeCancelledBets.map(
      (el: any) => ({
        betID: el.betId,
        extBetID: el.extBetID,
        status: "TO_BE_CANCELED",
      })
    );
    dispatch(
      setGameplayData({
        failedBets: [...cancelledBets, ...failedBets, ...toBeCancelledBets],
      })
    );
  }
};
